export default __webpack_public_path__ + "static/media/Instagram.f36331d0.svg";